import React from "react";
import {FiAlertTriangle} from "react-icons/fi";
import styled from "styled-components";
import {IconPlaceCircle} from "../modals/modal.info";

export const AlertErrorCont = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
`

export const IconAlertPlace = styled(IconPlaceCircle)`
    width: 48px;
    height: 48px;
    background-color: var(--it-text-dark-red);
`

export const AlertInfoText = styled.p`
    color: var(--it-text-white);
    font-family: 'Basis Grotesque Pro';
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 20px;

    &[data-red] {
        color: var(--it-text-red);
    }
    &[data-green] {
        color: var(--it-text-green);
    }
`

const FiAlertTriangleIcon = styled(FiAlertTriangle)`
    color: var(--it-text-white);
    stroke: currentColor;
`

export const AlertErrorSmall = ({children, title}) => {
	return (
		<AlertErrorCont>
			<IconAlertPlace>
				<FiAlertTriangleIcon
					size={20}
				/>
			</IconAlertPlace>
			<AlertInfoText data-red>
				{title}
			</AlertInfoText>
		</AlertErrorCont>
	)
}